export const SET_SOURCE_REQUEST = 'SET_SOURCE_REQUEST'

const initialState = {
  // host: '',
  CORE_API_HOST: '',
  nativeRequest: false
}

export const setSourceRequest = payload => ({
  type: SET_SOURCE_REQUEST,
  payload
})

const sourceRequest = (state = initialState, action) => {
  if (action.type === SET_SOURCE_REQUEST) {
    return {
      ...state,
      ...action.payload
    }
  }
  return state
}

export default sourceRequest
